export enum filterOptions {
    Open =  'Open Chats',
    Closed = 'Closed Chats',
    Unread = 'Unread Chats',
    Read = 'Read Chats'
}
